import type { Mission } from '../missions.ts'

export const sec: Mission = {
  id: "sec",
  name: "Securities and Exchange Commission",
  short: "SEC",
  call: "Investors",
  kind: "independent",
  community: "financial",
  url: "https://www.sec.gov/",
  established: 1934,
  palette: {
    primary: "#003056",
    secondary: "#9e6610",
    accent: "#f9b624",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Securities_and_Exchange_Commission.svg",
  },
  motif: "eagle",
  mission: {
    text: "The SEC’s mission is to protect investors; maintain fair, orderly, and efficient markets; and facilitate capital formation.",
    url: "https://www.sec.gov/about",
  },
  fact: {
    text: "The SEC was founded in 1934, at the height of the Great Depression.",
    url: "https://www.sec.gov/about/mission",
  },
  seal: {
    file: "public/seals/sec.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Securities_and_Exchange_Commission.svg",
  },
  identifier: {
    about: "https://www.sec.gov/about",
    accessibility: "https://www.sec.gov/about/accessibility-disability-program",
    foia: "https://www.sec.gov/foia",
    noFear: "https://www.sec.gov/about/divisions-offices/office-equal-employment-opportunity/no-fear-act-amended",
    oig: "https://www.sec.gov/office-inspector-general",
    performance: "https://www.sec.gov/about/budget-performance",
    privacy: "https://www.sec.gov/about/privacy-information",
  },
  media: {
    photos: [
      {
        file: "/media/sec-wall-street.jpg",
        small: "/media/sec-wall-street-sm.jpg",
        alt: "Federal Hall's columned facade at the head of Wall Street, seen from above with yellow taxis below",
        title: "Federal Hall National Memorial",
        creator: "National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Hall_National_Memorial_FEHA1054.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/sec-federal-hall.jpg",
        small: "/media/sec-federal-hall-sm.jpg",
        alt: "The Greek Revival portico of Federal Hall and its statue of George Washington among Wall Street towers",
        title: "Federal Hall National Memorial",
        creator: "National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Hall_National_Memorial_(ce790e26-1dd8-b71b-0b3f-97bc6a7ddcf3).JPG",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
